<script>
import TableGenericList from "@/components/instrument/TableGenericList"
import { mapState } from "vuex"

export default {
  name: "DQPRTable",
  components: {
    TableGenericList,
  },
  props: {
    site: {
      type: String,
      default: "",
    },
    facility: {
      type: String,
      default: "",
    },
    instrument: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      debounceTimer: null,
      dqprInfo: [],
      fields: [
        {
          key: "dqprno",
          label: "RECORD",
          sortable: true,
        },
        {
          key: "dqpr2DqprByDqprno.dqpr2QacodeByQacode.codedesc",
          label: "QA Code",
          sortable: true,
        },
        { 
          key: "truncatedComment",
          label: "LAST COMMENT",
          sortable: true,
        },
        { 
          key: "formattedEntryDate",
          label: "ISSUE DATE",
          sortable: true,
        },
      ],
    }
  },
  computed: {
    ...mapState("instrument", ["personInstruments"]),
    itemsLoaded() {
      return this.dqprInfo.length > 0
    },
  },
  watch: {
    personInstruments: {
      handler() {
        this.updateDqprInfo()
      },
      immediate: true,
    },
    site: {
      handler() {
        this.updateDqprInfo()
      },
      immediate: true,
    },
    facility: {
      handler() {
        this.updateDqprInfo()
      },
      immediate: true,
    },
    instrument: {
      handler() {
        this.updateDqprInfo()
      },
      immediate: true,
    },
    
    
  },
  created() {
    this.getDqprInfo()
  },
  methods: {
    getDqprInfo() {
      let filters = this.personInstruments.map(instr => ({
        site: instr.siteCode,
        facility: instr.facilityCode,
        instrument: instr.instrumentClassCode,
      }))

      // Apply site filter if a site is selected
      if (this.site) {
        filters = filters.filter(filter => filter.site === this.site)
      }

      // Apply facility filter if a facility is selected
      if (this.facility) {
        filters = filters.filter(filter => filter.facility === this.facility)
      }

      // Add instrument filter if an instrument is selected
      if (this.instrument) {
        filters = filters.filter(filter => filter.instrument === this.instrument)
      }

      this.$store.dispatch("instrument/retrieveDqprs", { filters })
        .then((data) => {
          this.dqprDateFormatter(data)
          this.getComments(data)
          this.dqprInfo = data
        })
        .catch((error) => {
          console.error("Error fetching DQPR Info:", error)
        })
    },

    updateDqprInfo() {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        let filters = this.personInstruments.map(instr => ({
          site: instr.siteCode,
          facility: instr.facilityCode,
          instrument: instr.instrumentClassCode,
        }))
        if (this.site) {
          filters = filters.filter(filter => filter.site === this.site)
        }
        if (this.facility) {
          filters = filters.filter(filter => filter.facility === this.facility)
        }
        if (this.instrument) {
          filters = filters.filter(filter => filter.instrument === this.instrument)
        }

        this.$store.dispatch("instrument/retrieveDqprs", { filters })
          .then((data) => {
            this.dqprDateFormatter(data)
            this.getComments(data)
            this.dqprInfo = data
          })
          .catch((error) => {
            console.error("Error updating DQPR Info:", error)
          })
      }, 100)
    },

    formattedDateValue(dateValue) {
      const dateObject = new Date(dateValue)
      const month = String(dateObject.getMonth() + 1).padStart(2, "0")
      const day = String(dateObject.getDate()).padStart(2, "0")
      const year = dateObject.getFullYear()
      return `${month}/${day}/${year}`
    },
    dqprDateFormatter(data) {
      data.forEach(item => {
        if (item.dqpr2DqprByDqprno && item.dqpr2DqprByDqprno.entryDate) {
          const entryDateValue = item.dqpr2DqprByDqprno.entryDate
          item.formattedEntryDate = this.formattedDateValue(entryDateValue)
        }
      })
    },
    getComments(data) {
      const maxLength = 300
      data.forEach((item) => {
        if (item.comments && item.comments.length > 0) {
          const latestComment = item.comments[0]
          item.latestComment = latestComment.comment
          item.latestCommentDate = this.formattedDateValue(latestComment.commentDate)
          item.truncatedComment = this.truncateText(item.latestComment, maxLength)
        } else {
          item.latestComment = ""
          item.latestCommentDate = ""
          item.truncatedComment = ""
        }
      })
    },
    truncateText(text, maxLength) {
      if (!text) return ""
      if (text.length <= maxLength) {
        return text
      }
      return `${text.substring(0, maxLength)}..............................................Click to read more.`
    },
  },
}
</script>
<template>
  <div id="tableView">
    <b-container class="gx-0">
      <b-row class="gx-0">
        <b-col class="gx-0">
          <div id="DQPRs" class="tableContainer">
            <h6 class="font-weight-bold pt-2 px-2 pb-0 mb-0 sectionHeader">DQPRs</h6>
            <TableGenericList :fields="fields" :records="dqprInfo">
              <template #cell(latestComment)="data">
                <div>
                  {{ data.item.latestComment }}
                  <br/>
                  <small v-if="data.item.latestCommentDate">{{ data.item.latestCommentDate }}</small>
                </div>
              </template>
            </TableGenericList>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<style scoped>
.tableContainer {
  background: #95c8fb;
}
</style>
